(($) ->

  $.fn.linedtextarea = (options) ->
    # Get the Options
    opts = $.extend({}, $.fn.linedtextarea.defaults, options)

    ###
    # Helper function to make sure the line numbers are always
    # kept up to the current system
    ###
    fillOutLines = (codeLines, h, lineNo) ->
      totalLines = 0
      while totalLines <= h
        if lineNo == opts.selectedLine
          codeLines.append '<div class=\'lineno lineselect\'>' + lineNo + '</div>'
        else
          codeLines.append '<div class=\'lineno\'>' + lineNo + '</div>'
        lineNo++
        totalLines += 15
      lineNo

    ###
    # Iterate through each of the elements are to be applied to
    ###

    @each ->
      lineNo = 1
      textarea = $(this)

      ### Turn off the wrapping of as we don't want to screw up the line numbers ###

      textarea.attr 'wrap', 'off'
      textarea.css resize: 'none'
      originalTextAreaWidth = textarea.outerWidth()

      ### Wrap the text area in the elements we need ###

      textarea.wrap '<div class=\'linedtextarea\'></div>'
      linedTextAreaDiv = textarea.parent().wrap('<div class=\'linedwrap\' style=\'width: 100%\'></div>')
      linedWrapDiv = linedTextAreaDiv.parent()
      linedWrapDiv.prepend '<div class=\'lines\' style=\'width:50px\'></div>'
      linesDiv = linedWrapDiv.find('.lines')
      linesDiv.height textarea.height() + 6

      ### Draw the number bar; filling it out where necessary ###

      linesDiv.append '<div class=\'codelines\'></div>'
      codeLinesDiv = linesDiv.find('.codelines')
      lineNo = fillOutLines(codeLinesDiv, linesDiv.height(), 1)

      ### Move the textarea to the selected line ###

      if opts.selectedLine != -1 and !isNaN(opts.selectedLine)
        fontSize = parseInt(textarea.height() / (lineNo - 2))
        position = parseInt(fontSize * opts.selectedLine) - (textarea.height() / 2)
        textarea[0].scrollTop = position

      ### Set the width ###

      sidebarWidth = linesDiv.outerWidth()
      paddingHorizontal = parseInt(linedWrapDiv.css('border-left-width')) + parseInt(linedWrapDiv.css('border-right-width')) + parseInt(linedWrapDiv.css('padding-left')) + parseInt(linedWrapDiv.css('padding-right'))
      textareaDiffWidth = sidebarWidth + paddingHorizontal + 20
      textarea.width "calc(100% - #{textareaDiffWidth}px)"
      linedWrapDiv.width "calc(100% - #{paddingHorizontal}px)"

      ### React to the scroll event ###

      textarea.scroll (tn) ->
        domTextArea = $(this)[0]
        scrollTop = domTextArea.scrollTop
        clientHeight = domTextArea.clientHeight
        codeLinesDiv.css 'margin-top': -1 * scrollTop + 'px'
        lineNo = fillOutLines(codeLinesDiv, scrollTop + clientHeight, lineNo)
        return

      ### Should the textarea get resized outside of our control ###

      textarea.resize (tn) ->
        domTextArea = $(this)[0]
        linesDiv.height domTextArea.clientHeight + 6
        return
      return

  # default options
  $.fn.linedtextarea.defaults =
    selectedLine: -1
    selectedClass: 'lineselect'
  return
) jQuery



// WEBPACK FOOTER //
// ./src/vendor/lined-textarea/jquery-linedtextarea.coffee